// extracted by mini-css-extract-plugin
module.exports = {"offcanvas-menu":"GbaVQ","sidebar":"_3ACaA","is-open":"LUXGb","overlay":"_2gDMR","overlay-active":"_1Av1h","close-icon-wrapper":"_1LBcD"};